import { api } from './client'

export interface DepartmentRow {
  id: string
  name: string
  slug: string
  order: number
  headUserId: string | null
}

export async function fetchDepartments(): Promise<DepartmentRow[]> {
  const r = await api.get<DepartmentRow[]>('/departments')
  return r.data
}

export interface DepartmentPayload {
  slug: string
  name: string
  order?: number
  head_user_id?: string | null
}

export async function createDepartment(body: DepartmentPayload): Promise<DepartmentRow> {
  const r = await api.post<DepartmentRow>('/departments', body)
  return r.data
}

export async function updateDepartment(id: string, body: Partial<DepartmentPayload>): Promise<DepartmentRow> {
  const r = await api.patch<DepartmentRow>(`/departments/${id}`, body)
  return r.data
}

export async function deleteDepartment(id: string): Promise<void> {
  await api.delete(`/departments/${id}`)
}
